"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
exports.Document = new (class {
    appendBodyChild(element) {
        document.body.appendChild(element);
    }
    appendHeadLink(links, onload) {
        links.forEach((link) => {
            if (onload)
                link.onload = onload;
            document.head.appendChild(link);
        });
    }
    createLink({ href, type = 'text/css', rel = 'stylesheet', crossorigin }) {
        const link = document.createElement('link');
        link.href = href;
        if (type)
            link.type = type;
        if (rel)
            link.rel = rel;
        if (crossorigin)
            link.crossOrigin = crossorigin;
        return link;
    }
    createApplicationShadowHost(applicationName, applicationStyleLinks, onload) {
        const applicationContainer = this.createApplicationContainer(applicationName);
        const applicationHead = this.createApplicationHead(applicationName);
        applicationStyleLinks.forEach((link) => applicationHead.appendChild(link));
        const applicationHost = this.createApplicationHost(applicationName, applicationHead, applicationContainer);
        applicationStyleLinks.forEach((link) => {
            link.onload = () => onload(applicationHead, applicationContainer);
        });
        return applicationHost;
    }
    createApplicationHead(applicationName) {
        const applicationHead = document.createElement('div');
        applicationHead.setAttribute('application-head', applicationName);
        return applicationHead;
    }
    createApplicationContainer(applicationName) {
        const applicationContainer = document.createElement('div');
        applicationContainer.setAttribute('application-body', applicationName);
        return applicationContainer;
    }
    createApplicationHost(applicationName, applicationHead, applicationContainer) {
        const applicationHost = document.createElement(applicationName);
        const applicationShadow = applicationHost.attachShadow({
            mode: 'closed',
        });
        applicationShadow.appendChild(applicationHead);
        applicationShadow.appendChild(applicationContainer);
        return applicationHost;
    }
})();
